module.exports = __webpack_public_path__ + "img/4.b7d7bb7c.jpg";